import { render, staticRenderFns } from "./sampleDesc.vue?vue&type=template&id=529de0d5&scoped=true"
import script from "./sampleDesc.vue?vue&type=script&lang=js"
export * from "./sampleDesc.vue?vue&type=script&lang=js"
import style0 from "./sampleDesc.vue?vue&type=style&index=0&id=529de0d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529de0d5",
  null
  
)

export default component.exports